import flatten from 'lodash/flatten'
import unionBy from 'lodash/unionBy'

/**
 * @param {ApiServiceTypeEdit} data
 * @returns {ServiceTypeEdit}
 */
export const parseServiceEdit = (data) => ({
  id: data.id,
  name: data.name,
})

/**
 * @param {ApiCategoryEdit} data
 * @returns {CategoryEdit}
 */
export const parseCategoryEdit = (data) => ({
  id: data.id,
  name: data.name,
  requiredQualification: data.requiredQualification,
  serviceTypes: data.serviceTypes.map(parseServiceEdit),
})

/**
 * @param {ApiGroupEdit} data
 * @returns {GroupEdit}
 */
export const parseGroupEdit = (data) => ({
  id: data.id,
  name: data.name,
  categories: data.categories.map(parseCategoryEdit),
})

/**
 * @param {string} categorySlug
 * @returns {(service: ApiServiceType) => CategoryPrefix}
 */
export const parseCategoryServicePrefix = (categorySlug) => (service) => {
  const serviceType = {
    id: service.id,
    name: service.searchName,
    slug: `${categorySlug}/${service.slug}`,
  }

  return serviceType
}

/**
 * @param {ApiCategory} item
 * @returns {CategoryPrefix[]}
 */
export const parseCategoryPrefix = (item) => {
  const { id, name, slug, serviceTypes } = item

  const category = { id, name, slug }

  const parseService = parseCategoryServicePrefix(slug)
  const serviceList = serviceTypes.map(parseService)

  return flatten([ category, serviceList])
}

/**
 * @param {ApiCategory[]} data
 * @return {CategoryPrefix[]}
 */
export const parseCategoryPrefixList = (data) => {
  let categorList = flatten(data.map(parseCategoryPrefix))

  return categorList
}

/**
 * @param {ApiServiceType} service
 * @returns {CategoryPrefix}
 */
export const parseServiceTypePrefix = (service) => {
  const serviceType = {
    id: service.id,
    name: service.searchName,
    slug: `${service.categorySlug}/${service.slug}`,
    slugServType: service.slug,
  }

  return serviceType
}

/**
 * @param {ApiGroup[]} data
 */
export const parseGroupOrder = (data) => {
  const findName = (name) => (item) => item.name === name

  const administration = data.find(findName('Administração e Jurídico'))
  const maintenance = data.find(findName('Manutenção e Prevenção'))
  const construction = data.find(findName('Obras e Reformas'))
  const convenience = data.find(findName('Conveniência e Atividades'))
  const products = data.find(findName('Produtos e Acessórios'))

  const firstGroup = [
    administration,
    maintenance,
    construction,
    convenience,
    products,
  ]

  return unionBy(firstGroup, data, 'id')
}

export default {
  parseServiceEdit,
  parseCategoryEdit,
  parseGroupEdit,
  parseCategoryServicePrefix,
  parseCategoryPrefix,
  parseCategoryPrefixList,
  parseServiceTypePrefix,
  parseGroupOrder,
}